import { PortableText } from '@portabletext/react'
import classNames from 'classnames'
import { useContext } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { s_materials } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { TEXT_SIZE, TextContext } from '../../../pages/[lang]/portal/materials/detail/[materialId]'
import LoadingSpinner from '../../common/LoadingSpinner'
import { block, marks, ptComponents, types, updateMarksToBreak } from '../../sanity/util'
import FreeTalkingBody from './FreeTalkingBody'

const MaterialTextBody = ({ insightData, materialData, isLoading, isModal }) => {
  const { t, isLocaleKO } = useTranslation()
  const { showKorean, textSize } = useContext(TextContext)
  return (
    <div className="mt-[28px]">
      <div className="leading-7 md:leading-6">
        {materialData?.course?.free_talking && <FreeTalkingBody materialData={materialData} />}

        {/* HTML parser text */}
        {isLoading ? (
          <div>
            <LoadingSpinner show primary />
          </div>
        ) : insightData && insightData.paragraphList ? (
          insightData?.paragraphList.map((item, i) => {
            const contentEn = updateMarksToBreak(item.paragraph_en.content)
            const contentKo = updateMarksToBreak(item.paragraph_ko.content)
            const isNoneText = (content) =>
              content && content.length === 1 && content[0].children && content[0].children[0].text === ''
            return (
              <div
                key={i}
                className={classNames(
                  textSize === TEXT_SIZE.SMALLER && 'Body2-14Md sm:Title2-18Md',
                  textSize === TEXT_SIZE.DEFAULT && 'Body1-16Md sm:Title1-20Md',
                  textSize === TEXT_SIZE.BIGGER && 'Title2-18Md sm:Headline3-22Md',
                  'new-theme lists-class mb-[16px] flex flex-col break-keep'
                )}
              >
                <PortableText
                  value={contentEn}
                  components={
                    isModal
                      ? {
                          block: block,
                          marks: marks,
                          types: types,
                        }
                      : ptComponents
                  }
                />
                {showKorean && !isNoneText(contentKo) && (
                  <div
                    className={classNames(
                      textSize === TEXT_SIZE.SMALLER && 'Body2-14Md sm:Body2-14Md',
                      textSize === TEXT_SIZE.DEFAULT && 'Body1-16Md sm:Body1-16Md',
                      textSize === TEXT_SIZE.BIGGER && 'Title2-18Md sm:Title2-18Md',
                      'lists-class = mt-[16px] break-keep rounded-[4px] bg-gray-50 p-[16px]  text-gray-700'
                    )}
                  >
                    <PortableText value={contentKo} components={ptComponents} />
                  </div>
                )}
              </div>
            )
          })
        ) : (
          <div
            style={{
              overflowX: 'hidden',
              wordBreak: 'keep-all',
            }}
            className={classNames('mx-auto mb-[50px]')}
          >
            {!showKorean
              ? ReactHtmlParser(materialData?.course?.summary_eng?.replace(/role="presentation"/g, '') || '')
              : ReactHtmlParser(materialData?.course?.summary_kor?.replace(/role="presentation"/g, '') || '')}
          </div>
        )}

        <div className="Body1-16Md my-[40px] rounded-[10px] bg-gray-100 p-[16px] text-gray-500">
          {t(s_materials.copyright_desc1)}
        </div>
      </div>
    </div>
  )
}

export default MaterialTextBody
